import { AppSettings } from '../app.settings';
import { MergeScreenFiltersDataModel } from './merge-screen-filters-data-model';

export class MergeScreenFilterModel {
  screenCode: String = AppSettings.FILTER_SCREEN_CODE.MERGE_BOOKINGS;
  filterData: MergeScreenFiltersDataModel = new MergeScreenFiltersDataModel();

  constructor(options?: {
    screenCode?: String,
    filterData: MergeScreenFiltersDataModel
  }) {
    if (options) {
      this.screenCode = options.screenCode;
      this.filterData = options.filterData;
    }
  }
};
